export default __webpack_public_path__ + "logo-eaep-f07d3e1f85f3609030b3f6f5410d6efc.svg";